<template>
  <Navbar />
  <router-view />
</template>

<script>
// @ is an alias to /src
import Navbar from "@/components/navbar.vue";

export default {
  name: "NaveBar",
  components: {
    Navbar
  }
};
</script>

<style>
@import url("https://fonts.googleapis.com/css2?family=Raleway:wght@400;500;700&display=swap");

* {
  box-sizing: border-box;
}

html {
  height: 100%;
  background-color: #000;
}

body {
  margin: 0;
  height: 100%;
  font-family: "Raleway", sans-serif;
}

.container {
  position: relative;
  width: 100%;
  height: auto;
}

/* a {
  color: #000;
  font-weight: bold;
  margin: 0;
  padding: 0;
  border: 0;
  font-size: 125%;
  font-family: "Raleway", sans-serif;
  vertical-align: baseline;
  text-decoration: none;
} */

h2 {
  color: #686262;
  display: inline-block;
  font-size: 3.5em;
  line-height: 1.35;
  margin-bottom: 0.5em;
}

p {
  color: #000;
  /* margin: 0 0 2em 0; */
}

#footer {
  padding: 1em 0 0.5em 0;
  /* background: #f6f6f6; */
  color: #aaa;
  text-align: center;
}

#footer a {
  color: #aaa;
  font-weight: normal;
}

/* -------------- Cell -----------------*/

@media (max-width: 775px) {
  h2 {
    font-size: 1.5em;
  }
}
</style>
